import { Store } from "src/store";
import { setSignIn } from "src/store/actions/onlineShopper/signIn";
import { toggleModal } from "src/store/actions/openModal";

export default function signIn(store: Store) {
    const state = store.getState();

    // If we're already open, don't do anything
    if (state.onlineShopper.isAppOpen) {
        return;
    }

    void store.dispatch(toggleModal("sm"));

    if (!store.getState().onlineShopper.isAuthed) {
        void store.dispatch(setSignIn({ routeSignIn: true }));
    }
}
